import { render } from "./BookingConfirmationBanner.vue?vue&type=template&id=5504f263"
import script from "./BookingConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__